export default __webpack_public_path__ + "static/media/error.a19e4d51.mp3";